import React, { Component } from 'react';

export default class BeforeAdditional extends Component {
  render() {
    return (
      <section className='additional'>
          <header className='additional__title'>
            ДВА ПОТОКА
          </header>

        <section className='additional__column additional__column_left'>
          <p className='additional__p'>
            Для тех, кто в&nbsp;первый раз на&nbsp;конференции и&nbsp;школьников 10-11&nbsp;классов. Обзорные доклады об&nbsp;информационных технологиях, о&nbsp;том, как устроена работа в&nbsp;этой индустрии, где и&nbsp;чему учиться. Знакомство на&nbsp;стендах с&nbsp;омскими ИТ-компаниями, информация о&nbsp;курсах.
          </p>
          {/*<p className='additional__p'>*/}
            {/*При регистрации выбери <br /><span className='additional__span'>&laquo;Я&nbsp;первый раз иду на&nbsp;конференцию&raquo;</span>*/}
          {/*</p>*/}
        </section>
        <section className='additional__column additional__column_right'>
          <p className='additional__p'>
            Для тех, кто уже был на&nbsp;конференции и&nbsp;хочет попасть на&nbsp;стажировку в&nbsp;ИТ-компанию&nbsp;&mdash; доклады с&nbsp;техническими подробностями и&nbsp;о&nbsp;том, как устроена работа в&nbsp;компании. Информация на&nbsp;стендах о&nbsp;стажировках и&nbsp;вакансиях в&nbsp;ИТ-компаниях Омска.
          </p>
          {/*<p className='additional__p'>*/}
            {/*При регистрации выбери <br /><span className='additional__span'>&laquo;Я&nbsp;уже был на&nbsp;конференции&raquo;</span>*/}
          {/*</p>*/}
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing/blocks/BeforeAdditional.js